<template>
  <v-container
    class="cmp-settings-booking-settings dt-sidewindow submodule-root"
  >
    <div class="dt-tabs-container submodule-root">
      <glayout
        :tabs="bookingSettingsTabs"
        :loading="bookingSettingsData && bookingSettingsData.loading"
        tabPanelColor="secondary"
      >
        <gtab>
          <grow>
            <gcol>
              <gbox
                :h="
                  boxHeight(
                    bookingSettingsData &&
                      bookingSettingsData.statuses &&
                      bookingSettingsData.statuses.length,
                    NTOffsets.WithDBoxBottom
                  )
                "
                :title="$t('booking_status')"
              >
                <BookingStatuses
                  v-if="bookingSettingsData"
                  :statuses="bookingSettingsData.statuses"
                  @color_changed="onColorChange"
                  @added="onBookingStatusAddClick"
                  @deleted="onBookingStatusDeleteClick"
                />
              </gbox>
              <gbox
                :h="
                  boxHeight(
                    bookingSettingsData &&
                      bookingSettingsData.travel_options &&
                      bookingSettingsData.travel_options.length,
                    NTOffsets.WithDBoxBottom
                  )
                "
                :title="$t('travel_options')"
              >
                <DBox
                  v-if="bookingSettingsData"
                  :id="'cmp-settings-booking-travel-options'"
                  :addButton="false"
                  :addLink="true"
                  :addLinkLabel="`${$t('add_travel_option')}`"
                  @add_click="onAddNewTravelOption"
                >
                  <DList
                    v-if="bookingSettingsData"
                    :items="bookingSettingsData.travel_options"
                    :primaryKey="'travel_option_id'"
                    :labelKey="'travel_option_text'"
                    @delete="onTravelOptionDelete"
                    @item_click="onTravelOptionClick"
                  />
                </DBox>
              </gbox>
            </gcol>
            <gcol>
              <gbox :title="$t('booking_defaults')" h="232">
                <!-- <gbox :title="$t('booking_defaults')" h="164"> -->
                <div v-if="bookingSettingsData" class="booking-defaults-form">
                  <TextField2
                    :id="'tripit_ical'"
                    :placeholder="$t('tripit')"
                    :label="$t('tripit')"
                    :value="client.tripit_ical"
                    @blur="onBookingDefaultValueChange"
                    lw="65%"
                    style="height: 30px"
                  />
                  <!-- :placeholder="
                    'Days before event to notify of unsigned contracts [0] = OFF :'
                  " -->
                  <div class="fc2-auto-height">
                    <TextField2
                      :id="'settings_notify_contracts'"
                      :value="client.settings_notify_contracts"
                      :height="55"
                      :placeholder="$t('notify_days_event_unsigned_contract')"
                      :label="$t('notify_days_event_unsigned_contract')"
                      @blur="onBookingDefaultValueChange"
                      lw="65%"
                    />
                    <!-- :textarea="true"
                    :height="55" -->
                  </div>
                  <div class="fc2-auto-height">
                    <!-- :placeholder="'Send to email, leave blank for default'" -->
                    <TextField2
                      :id="'settings_notify_contracts_email'"
                      :placeholder="$t('send_to_email_string')"
                      :label="$t('send_to_email_string')"
                      :value="client.settings_notify_contracts_email"
                      :height="55"
                      @blur="onBookingDefaultValueChange"
                      lw="65%"
                    />
                    <!-- :textarea="true"
                    :height="55" -->
                  </div>
                  <div class="fc2-auto-height">
                    <!-- :placeholder="
                      'Days before event to notify of unfilled questionnaire [0] = OFF :'
                    " -->
                    <TextField2
                      :id="'settings_notify_questionnaire'"
                      :placeholder="
                        $t('notify_days_event_unfilled_questionnaire')
                      "
                      :label="$t('notify_days_event_unfilled_questionnaire')"
                      :value="client.settings_notify_questionnaire"
                      :height="55"
                      @blur="onBookingDefaultValueChange"
                      lw="65%"
                      bb="0px"
                    />
                    <!-- :textarea="true"
                    :height="55" -->
                  </div>
                </div>
              </gbox>
              <gbox :title="$t('lock_for_questionaire_default')" h="132">
                <div class="questionaire-lock-defaults-form" v-if="bookingSettingsData">
                  <!-- <div class="dt-list">
                    <div class="dt-list-item" style="border-bottom: none;" v-for="cl of lockJsonTypes" :key="cl.key">
                      <div class="dt-list-item--options">
                        <div class="dt-checkbox v2 s1">
                          <input
                            type="checkbox"
                            @click="(e) => onLockJsonCheckboxChange(e, cl)"
                            :name="cl.key"
                            :id="cl.key"
                            :checked="cl.value == 1"
                          />
                          <div class="checkmark"></div>
                        </div>
                      </div>
                      <div class="dt-list-item--body" style="margin: -3px 0 0 10px">
                        {{ $t(cl.text) }}
                      </div>
                    </div>
                  </div> -->
                    <div class="ut-fc">
                      <Checkbox2
                        v-for="(cl, index) of lockJsonTypes" :key="cl.key"
                        style="flex:1"
                        :disabled="false"
                        :id="cl.key"
                        :label="$dft.capHead(cl.text)"
                        :checked="cl.value == 1"
                        :value="cl.value"
                        :placeholder="$dft.capHead(cl.text)"
                        :lw="'115px'"
                        @input="onLockJsonCheckboxChange"
                        :bb="index == lockJsonTypes.length - 1 ? 'none' : undefined"
                      />
                  </div>
                </div>
              </gbox>
            </gcol>
          </grow>
        </gtab>
        <gtab id="request_settings" :title="$t('tab_title_request_settings')">
          <!-- <template #header>
            <grow>
              <gcol>
                <div class="ut-flex">
                  <button
                    @click="onSaveClick"
                    style="margin-left: 0px"
                    class="dt-button v5 s8"
                  >
                    {{ $t("save") }}
                  </button>
                </div>
              </gcol>
            </grow>
          </template> -->
          <grow>
            <gcol>
              <gbox
                :h="
                  boxHeightNamed({
                    rowCount: contactFields.length,
                    offset: NTOffsets.WithHeaderDBoxBottom,
                    rowHeight: 32,
                    min: 0,
                    max: 15,
                  })
                "
                :title="$t('contact')"
              >
                <FieldTable
                  v-if="bookingSettingsData"
                  :linkLabelName="`${$t('add_contact')}`"
                  :custom_fields="[
                    ...custom_fields.contact_fields,
                    ...bookingSettingsData.contact_fields,
                  ]"
                  :conf="bookingSettingsData.conf.contact"
                  @changed="(e) => onConfChanged('contact', e)"
                  @field_changed="
                    (e) => onFieldChanged(e, 'contact_fields', 'contact')
                  "
                  @add_click="onAddField('contacts')"
                  @delete="
                    (e) => onCustomFieldDelete('contact_fields', e, 'contact')
                  "
                  @saveSettings="onSaveClick"
                />
              </gbox>
              <!-- {{
                custom_fields.promoter_fields &&
                  custom_fields.promoter_fields.length
              }} -->
              <!-- :h="
                  boxHeight(
                    custom_fields.promoter_fields &&
                      custom_fields.promoter_fields.length,
                    NTOffsets.WithHeaderDBoxBottom
                  )
                " -->
              <gbox
                :h="
                  boxHeightNamed({
                    rowCount: promoterFields.length,
                    offset: NTOffsets.WithHeaderDBoxBottom,
                    rowHeight: 32,
                    min: 0,
                    max: 15,
                  })
                "
                :title="$t('promoter')"
              >
                <FieldTable
                  v-if="bookingSettingsData"
                  :linkLabelName="`${$t('add_promoter')}`"
                  :custom_fields="[
                    ...custom_fields.promoter_fields,
                    ...bookingSettingsData.promoter_fields,
                  ]"
                  :conf="bookingSettingsData.conf.promoter"
                  @changed="(e) => onConfChanged('promoter', e)"
                  @field_changed="
                    (e) => onFieldChanged(e, 'promoter_fields', 'promoter')
                  "
                  @add_click="onAddField('promoters')"
                  @delete="
                    (e) => onCustomFieldDelete('promoter_fields', e, 'promoter')
                  "
                  @saveSettings="onSaveClick"
                />
              </gbox>
              <!-- :h="
                  boxHeight(
                    custom_fields &&
                      custom_fields.location_fields &&
                      custom_fields.location_fields.length,
                    NTOffsets.WithHeaderDBoxBottom
                  )
                " -->
              <gbox
                :h="
                  boxHeightNamed({
                    rowCount: locationFields.length,
                    offset: NTOffsets.WithHeaderDBoxBottom,
                    rowHeight: 32,
                    min: 0,
                    max: 15,
                  })
                "
                :title="$t('venue')"
              >
                <FieldTable
                  v-if="bookingSettingsData"
                  :linkLabelName="`${$t('add_venue')}`"
                  :custom_fields="[
                    ...custom_fields.location_fields,
                    ...bookingSettingsData.location_fields,
                  ]"
                  :conf="bookingSettingsData.conf.booking_location"
                  @changed="(e) => onConfChanged('booking_location', e)"
                  @field_changed="
                    (e) =>
                      onFieldChanged(e, 'location_fields', 'booking_location')
                  "
                  @add_click="onAddField('booking_locations')"
                  @delete="
                    (e) =>
                      onCustomFieldDelete(
                        'location_fields',
                        e,
                        'booking_location'
                      )
                  "
                  @saveSettings="onSaveClick"
                />
              </gbox>
            </gcol>
            <gcol>
              <!-- {{
                custom_fields.event_fields && custom_fields.event_fields.length
              }} -->
              <!-- :h="
                  boxHeight(
                    custom_fields &&
                      custom_fields.event_fields &&
                      custom_fields.event_fields.length,
                    NTOffsets.WithHeaderDBoxBottom
                  )
                " -->
              <gbox
                :h="
                  boxHeightNamed({
                    rowCount: eventFields.length,
                    offset: NTOffsets.WithHeaderDBoxBottom,
                    rowHeight: 32,
                    min: 0,
                    max: 15,
                  })
                "
                :title="$t('event_l')"
              >
                <FieldTable
                  v-if="bookingSettingsData"
                  :linkLabelName="`${$t('add_event')}`"
                  :custom_fields="[
                    ...custom_fields.event_fields,
                    ...bookingSettingsData.event_fields,
                  ]"
                  :conf="bookingSettingsData.conf.calendar_date"
                  @changed="(e) => onConfChanged('calendar_date', e)"
                  @field_changed="
                    (e) => onFieldChanged(e, 'event_fields', 'calendar_date')
                  "
                  @add_click="onAddField('calendar_dates')"
                  @delete="
                    (e) =>
                      onCustomFieldDelete('event_fields', e, 'calendar_date')
                  "
                  @saveSettings="onSaveClick"
                />
              </gbox>
              <!-- :h="
                  boxHeight(
                    custom_fields &&
                      custom_fields.artist_fields &&
                      custom_fields.artist_fields.length,
                    NTOffsets.WithHeaderDBoxBottom
                  )
                " -->
              <gbox
                :h="
                  boxHeightNamed({
                    rowCount: artistFields.length,
                    offset: NTOffsets.WithHeaderDBoxBottom,
                    rowHeight: 32,
                    min: 0,
                    max: 15,
                  })
                "
                :title="$t('artists')"
              >
                <FieldTable
                  v-if="bookingSettingsData"
                  :linkLabelName="`${$t('add_artist')}`"
                  :custom_fields="[
                    ...custom_fields.artist_fields,
                    ...bookingSettingsData.artist_fields,
                  ]"
                  :conf="bookingSettingsData.conf.calendar_date_artist"
                  @changed="(e) => onConfChanged('calendar_date_artist', e)"
                  @field_changed="
                    (e) =>
                      onFieldChanged(e, 'artist_fields', 'calendar_date_artist')
                  "
                  @add_click="onAddField('calendar_date_artists')"
                  @delete="
                    (e) =>
                      onCustomFieldDelete(
                        'artist_fields',
                        e,
                        'calendar_date_artist'
                      )
                  "
                  @saveSettings="onSaveClick"
                />
              </gbox>
            </gcol>
          </grow>
        </gtab>
        <gtab
          id="local_details_settings"
          :title="$t('tab_title_bookinglocaldetails_settings')"
        >
          <grow>
            <gcol>
              <gbox
                :h="
                  boxHeight(
                    booking_localdetail_settingsCustomFieldLength,
                    NTOffsets.WithHeaderDBoxBottom
                  )
                "
                :title="$t('local_details')"
              >
                <LocalDetailsSettings
                  v-if="bookingSettingsData"
                  :bookingSettingsData="bookingSettingsData"
                  @add_click="onLocalDetailsAddClick"
                  @delete="onLocalDetailsTypeDeleted"
                  @ldt_changed="onLocalDetailsTypeChanged"
                  @ld_field_changed="onLocalDetailsFieldChanged"
                  @ld_field_deleted="onLocalDetailsFieldDeleted"
                />
              </gbox>
            </gcol>
          </grow>
        </gtab>
        <gtab id="money_details">
          <grow>
            <gcol>
              <gbox
                :h="
                  boxHeight(
                    bookingSettingsData &&
                      bookingSettingsData.invoice_items &&
                      bookingSettingsData.invoice_items.length,
                    NTOffsets.WithHeaderDBoxBottom
                  )
                "
                :title="$t('money_details')"
              >
                <MoneyDetailsSettings
                  v-if="bookingSettingsData"
                  :bookingSettingsData="bookingSettingsData"
                  @add_click="onInvoiceLineAddClick"
                  @delete="onInvoiceItemDeleted"
                />
              </gbox>
            </gcol>
          </grow>
          <grow>
            <gcol>
              <gbox
                :h="
                  boxHeight(
                    bookingSettingsData &&
                      bookingSettingsData.invoice_itemgroups &&
                      bookingSettingsData.invoice_itemgroups.length,
                    NTOffsets.WithDBoxBottom
                  )
                "
                :title="$t('invoice_line_group')"
              >
                <InvoiceGroups
                  v-if="bookingSettingsData"
                  :bookingSettingsData="bookingSettingsData"
                  :selectedInvoiceGroup="selectedInvoiceGroup"
                  @selected="onInvoiceGroupSelected"
                  @delete="onInvoiceGroupDeleted"
                  @add_click="onInvoiceGroupAddClick"
                />
              </gbox>
            </gcol>
            <gcol>
              <gbox
                :title="$t('invoice_group_items')"
                :h="
                  boxHeightNamed({
                    rowCount:
                      bookingSettingsData &&
                      bookingSettingsData.invoice_group_items &&
                      bookingSettingsData.invoice_group_items.length,
                    offset:
                      bookingSettingsData &&
                      bookingSettingsData.invoice_group_items &&
                      bookingSettingsData.invoice_group_items.length > 0
                        ? NTOffsets.default
                        : NTOffsets.default + 64,
                    min: 1,
                  })
                "
              >
                <div
                  v-if="bookingSettingsData"
                  class="invoice-group-items-container"
                  :class="{
                    dragover: invoiceGroupItemsDragover,
                    showselecttext: !selectedInvoiceGroup || dragDropFlag,
                  }"
                  @drop="onInvoiceGroupItemsDrop"
                  @dragover="onInvoiceGroupItemsDragover"
                  @dragleave="onInvoiceGroupItemsDragleave"
                >
                  <LoadingUI
                    v-if="
                      bookingSettingsData &&
                      bookingSettingsData.invoice_group_items_loading
                    "
                  />
                  <div v-else class="select-text">
                    {{
                      !dragDropFlag
                        ? $t('select_a_invoice_line_group_to')
                        : $t('drag_and_drop_an_invoice_item_to')
                    }}
                  </div>
                  <!-- <LoadingUI /> -->
                  <DList
                    :items="
                      bookingSettingsData
                        ? bookingSettingsData.invoice_group_items &&
                          bookingSettingsData.invoice_group_items.length > 0
                          ? bookingSettingsData.invoice_group_items
                          : []
                        : []
                    "
                    :primaryKey="'invoice_item_id'"
                    :labelKey="'item_name'"
                    @delete="onInvoiceGroupItemDelete"
                  />
                </div>
              </gbox>
            </gcol>
          </grow>
        </gtab>
        <gtab id="tasks">
          <grow>
            <gcol>
              <gbox
                :h="
                  boxHeight(
                    bookingSettingsData &&
                      bookingSettingsData.booking_task_templates &&
                      bookingSettingsData.booking_task_templates.length,
                    NTOffsets.WithHeaderDBoxBottom
                  )
                "
                :title="$t('tab_title_tasks')"
              >
                <SettingsTaskTemplates
                  v-if="bookingSettingsData"
                  :settingsData="bookingSettingsData"
                  :externalTable="'booking'"
                />
                <!-- @add_click="onTaskTemplateAddClick"
                  @delete="onTaskTemplateDeleted" -->
              </gbox>
            </gcol>
          </grow>
          <grow>
            <gcol>
              <gbox
                :h="
                  boxHeight(
                    bookingSettingsData &&
                      bookingSettingsData.booking_task_template_groups &&
                      bookingSettingsData.booking_task_template_groups.length,
                    NTOffsets.WithDBoxBottom
                  )
                "
                :title="$t('task_template_group')"
              >
                <SettingsTaskTemplateGroups
                  v-if="bookingSettingsData"
                  :settingsData="bookingSettingsData"
                  :externalTable="'booking'"
                  @selected="onTaskTemplateGroupSelected"
                 
                  @updated="onTaskTemplateGroupUpdated"
                 
                />
                <!-- @delete="onTaskTemplateGroupDeleted" -->
                <!-- @add_click="onTemplateTaskGroupAddClick" -->
              </gbox>
            </gcol>
            <gcol>
              <gbox
                :title="$t('task_template_group_items')"
                :h="
                  boxHeightNamed({
                    rowCount:
                      bookingSettingsData &&
                      bookingSettingsData.booking_task_templates_of_group &&
                      bookingSettingsData.booking_task_templates_of_group.length,
                    offset:
                      bookingSettingsData &&
                      bookingSettingsData.booking_task_templates_of_group &&
                      bookingSettingsData.booking_task_templates_of_group.length > 0
                        ? NTOffsets.default
                        : NTOffsets.default + 64,
                    min: 1,
                  })
                "
              >
                <SettingsTaskGroupItem :externalTable="'booking'" :settingsData="bookingSettingsData" v-if="bookingSettingsData"/>
                <!-- <div
                  v-if="bookingSettingsData"
                  class="invoice-group-items-container"
                  :class="{
                    dragover: invoiceGroupItemsDragover,
                    showselecttext: !selectedTaskTemplateGroup || dragDropFlagTaskTemplageGroup,
                  }"
                  @drop="onTaskTemplateGroupItemsDrop"
                  @dragover="onTaskTemplateGroupItemsDragover"
                  @dragleave="onTaskTemplateGroupItemsDragleave"
                >
                  <LoadingUI
                    v-if="
                      bookingSettingsData &&
                      bookingSettingsData.task_templates_of_group_loading
                    "
                  />
                  <div v-else class="select-text">
                    {{
                      !dragDropFlagTaskTemplageGroup
                        ? $t('select_a_task_group_to_view_task')
                        : $t('drag_and_drop_a_task_template_to')
                    }}
                  </div>
                   <LoadingUI /> 
                  <DList
                    :items="
                      bookingSettingsData
                        ? bookingSettingsData.task_templates_of_group &&
                          bookingSettingsData.task_templates_of_group.length > 0
                          ? bookingSettingsData.task_templates_of_group
                          : []
                        : []
                    "
                    :primaryKey="'task_template_id'"
                    :labelKey="'task_template_name'"
                    @delete="onTaskTemplateGroupItemDelete"
                  />
                </div> -->
              </gbox>
            </gcol>
          </grow>
        </gtab>
        <gtab id="sharing" :title="$t('tab_title_sharing')">
          <grow>
            <gcol>
              <gbox
                :h="
                  boxHeight(
                    bookingSettingsData &&
                      bookingSettingsData.artists &&
                      bookingSettingsData.artists.length,
                    NTOffsets.default
                  )
                "
                :title="$t('rss_feeds')"
              >
                <RSSFeed
                  v-if="bookingSettingsData"
                  :artists="bookingSettingsData.artists"
                  :rssList="rssList"
                  @get_rsslist="getRssList"
                ></RSSFeed>
              </gbox>
            </gcol>
            <gcol>
              <gbox v-if="bookingSettingsData" :title="$t('sharing_content')"
                ><BookingRequestForm
                  v-if="bookingSettingsData"
                  :clientName="clientName"
                  :serverName="bookingSettingsData.server"
                ></BookingRequestForm
              ></gbox>
            </gcol>
          </grow>
        </gtab>
      </glayout>
    </div>

    <ModalContainer :modalKey="'editStatus'" :width="'small'">
      <BookingStatusForm
        @edited="onBookingStatusEdited"
        @cancelled="onModalCancelled"
      />
    </ModalContainer>
    <ModalContainer :modalKey="'addStatus'" :width="'small'">
      <BookingStatusForm
        @added="onBookingStatusAdded"
        @cancelled="onModalCancelled"
      />
    </ModalContainer>
    <ModalContainer :modalKey="'editTravelOption'" :width="'small'">
      <QuickModal
        :value="travelOptionText"
        :title="$t('edit_travel_option')"
        :placeholder="$t('edit_travel_option_text')"
        @cancelled="onModalCancelled"
        @ok="onTravelOptionEdited"
      />
    </ModalContainer>
    <ModalContainer :modalKey="'addTravelOption'" :width="'small'">
      <QuickModal
        :value="travelOptionText"
        :title="$t('add_new_travel_option')"
        :placeholder="$t('new_travel_option_text')"
        @cancelled="onModalCancelled"
        @ok="onNewTravelOptionAdded"
      />
    </ModalContainer>
    <ModalContainer :modalKey="'addCustomField'" :width="'small'">
      <QuickModal
        :title="$t(this.getCustomFieldTitle(this.external_table))"
        :placeholder="$t('field_label')"
        @cancelled="onModalCancelled"
        @ok="onNewCustomFieldAdd"
      />
    </ModalContainer>
    <ModalContainer :modalKey="'addLocalDetailsField'" :width="'small'">
      <QuickModal
        :title="$t('contact')"
        :placeholder="$t('field_label')"
        @cancelled="onModalCancelled"
        @ok="onNewLocalDetailsFieldAdded"
      />
    </ModalContainer>
    <ModalContainer :modalKey="'addLocalDetails'" :width="'small'">
      <QuickModal
        :title="$t('add_local_details')"
        :fields="addLocalDetailsFields"
        @cancelled="onModalCancelled"
        @ok="onAddLocalDetailsOk"
      />
    </ModalContainer>
    <ModalContainer :modalKey="'invoiceItemForm'" :width="'small'">
      <InvoiceItemForm
        @done="onInvoiceItemFormDone"
        @cancelled="onModalCancelled"
      />
    </ModalContainer>
    <ModalContainer :modalKey="'addInvoiceGroup'" :width="'small'">
      <QuickModal
        :title="$t('invoice_line_group')"
        :placeholder="$t('group_name')"
        @cancelled="onModalCancelled"
        @ok="onNewInvoiceGroupCreated"
      />
    </ModalContainer>
    <!-- <ModalContainer :modalKey="'taskTemplateForm'" :width="'small'">
      <TaskTemplateForm
        @done="onTaskTemplateFormDone"
        @cancelled="onModalCancelled"
      />
    </ModalContainer> -->
    <!-- <ModalContainer :modalKey="'addTaskTemplateGroup'" :width="'small'">
      <QuickModal
        :title="$t('task_template_group')"
        :placeholder="$t('group_name')"
        @cancelled="onModalCancelled"
        @ok="onNewTaskTemplateGroupCreated"
      />
    </ModalContainer> -->
  </v-container>
</template>

<script>
import DBox from "@dtplugins/dbox/dbox";
import DList from "@dtplugins/list/dlist";
import * as ActionTypes from "../../store/types";
import { mapKeyToAction } from "../../../../store/global";
import { SettingsStoreNamespace as storeNS } from "../../store";
import { mapGetters } from "vuex";
import { createDTGridHost } from "../../../../dt-plugins/dt-grid/dt-grid.mixin";
import {
  createModalMixin,
  closeModalRoute,
  openModalRoute,
} from "../../../../dt-plugins/modal/modal.mixin";
import QuickModal from "@plugins/quickmodal/quickmodal";
import { createFields } from "../../../../plugins/quickmodal";
import ModalContainer from "@dtplugins/modal/modal-container";
import {
  createTextFieldConfig,
  EventHooks,
} from "../../../../plugins/text-field";
import { JSONX } from "../../../../utility";
import { LoadingUI } from "@plugins/loading/loading";
import { NotificationService } from "../../../../dt-plugins/notification/notification.service";
import { ConfirmationService } from "../../../../dt-plugins/confirmation/confirmation.service";
import { confirmDelete } from "@/dt-plugins/confirmation/confirmation-common";
import { UPDATE_CLIENT } from "../../../../store/app/types";
import { clientName } from "../../../../services/http/http-client";

import BookingStatuses from "./booking-statuses";
import BookingStatusForm from "./booking-status-form";
import MoneyDetailsSettings from "./money-details-settings";
import InvoiceItemForm from "./invoice-item-form";
import InvoiceGroups from "./invoice-groups";
import LocalDetailsSettings from "./local-details-settings";
import * as custom_fields from "./custom-fields";
import FieldTable from "./field-table";
import BookingRequestForm from "./booking-request-form";
import RSSFeed from "./rss-feed";
import TaskTemplates from "./task-templates";
import TaskTemplateGroups from "./task-template-groups";
import TaskTemplateForm from "./task-template-form";
import { setMainNavInactive } from "../../../../store/app/mutations";
import SettingsTaskTemplateGroups from "../settings-plugins/settings-task-template-groups.vue";
import SettingsTaskTemplates from "../settings-plugins/settings-task-templates.vue";
import SettingsTaskGroupItem from "../settings-plugins/settings-task-group-item.vue";
export default {
  components: {
    DBox,
    DList,
    QuickModal,
    ModalContainer,
    LoadingUI,

    BookingStatuses,
    BookingStatusForm,
    FieldTable,
    LocalDetailsSettings,
    MoneyDetailsSettings,
    InvoiceItemForm,
    InvoiceGroups,
    BookingRequestForm,
    RSSFeed,
    TaskTemplates,
    TaskTemplateGroups,
    TaskTemplateForm,
    SettingsTaskTemplates,
    SettingsTaskTemplateGroups,
    SettingsTaskGroupItem
  },
  mounted: function () {
    setMainNavInactive(this.$store.commit, false);

    this.fetchData();
  },
  data: function () {
    return {
      textFieldConfig: createTextFieldConfig({
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: false,
        valueChangedEvent: EventHooks.OnBlur,
      }),

      icalLink: "",
      daysBeforeUC: "",
      sendEmail: "",
      daysBeforeUQ: "",

      custom_fields: custom_fields,

      confChangeFlag: false,
      addLocalDetailsFields: createFields([
        {
          key: "local_details_type_name",
          value: "",
          placeholder: "Local Details Type Name",
        },
        { key: "sequence", value: "", placeholder: "Sequence" },
      ]),
      selectedInvoiceGroup: null,
      invoiceGroupItemsDragover: false,
      clientName: clientName,
      selectedTaskTemplateGroup: null,
      taskTemplateGroupItemsDragover: false,
    };
    //MARK: Data Function
  },
  mixins: [
    createDTGridHost(),
    createModalMixin("editStatus"),
    createModalMixin("addStatus"),
    createModalMixin("editTravelOption"),
    createModalMixin("addTravelOption"),
    createModalMixin("addCustomField"),
    createModalMixin("addLocalDetailsField"),
    createModalMixin("addLocalDetails"),
    createModalMixin("invoiceItemForm"),
    createModalMixin("addInvoiceGroup"),
    createModalMixin("taskTemplateForm"),
    createModalMixin("addTaskTemplateGroup"),
  ],
  computed: {
    ...mapGetters(["account"]),
    ...mapGetters(storeNS, {
      bookingSettingsData: "bookingSettingsData",
    }),
    ...mapGetters(storeNS, { rssList: "rssList" }),

    bookingSettingsTabs: function () {
      return [
        {
          route: "overview",
          value: this.$t("booking_status"),
        },
        {
          route: "request_settings",
          value: this.$t("tab_title_request_settings"),
        },
        {
          route: "local_details_settings",
          value: this.$t("tab_title_bookinglocaldetails_settings"),
        },
        {
          route: "money_details",
          value: this.$t("tab_title_new_deals"),
        },
        // {
        //   route: "tasks",
        //   value: this.$t("tab_title_tasks"),
        // },
        {
          route: "sharing",
          value: this.$t("tab_title_sharing"),
        },
      ];
    },
    travelOptionText: function () {
      return this.$route.query.travel_option;
    },
    external_table: function () {
      return this.$route.query.external_table;
    },
    dragDropFlag: function () {
      if (this.selectedInvoiceGroup) {
        if (this.bookingSettingsData.invoice_group_items) {
          if (this.bookingSettingsData.invoice_group_items.length > 0) {
            return false;
          } else {
            return true;
          }
        } else {
          return true;
        }
      } else {
        return false;
      }
    },
    dragDropFlagTaskTemplageGroup: function () {
      if (this.selectedTaskTemplateGroup) {
        if (this.bookingSettingsData.task_templates_of_group) {
          if (this.bookingSettingsData.task_templates_of_group.length > 0) {
            return false;
          } else {
            return true;
          }
        } else {
          return true;
        }
      } else {
        return false;
      }
    },
    client: function () {
      return this.account?.client || {};
    },

    // ...bookingSettingsData.contact_fields,
    // ...bookingSettingsData.promoter_fields,
    // ...bookingSettingsData.location_fields,
    // ...bookingSettingsData.event_fields,
    // ...bookingSettingsData.artist_fields,

    contactFields: function () {
      return [
        ...(this.custom_fields?.contact_fields || []),
        ...(this.bookingSettingsData?.contact_fields || []),
      ];
    },
    promoterFields: function () {
      return [
        ...(this.custom_fields?.promoter_fields || []),
        ...(this.bookingSettingsData?.promoter_fields || []),
      ];
    },
    locationFields: function () {
      return [
        ...(this.custom_fields?.location_fields || []),
        ...(this.bookingSettingsData?.location_fields || []),
      ];
    },
    eventFields: function () {
      return [
        ...(this.custom_fields?.event_fields || []),
        ...(this.bookingSettingsData?.event_fields || []),
      ];
    },
    artistFields: function () {
      return [
        ...(this.custom_fields?.artist_fields || []),
        ...(this.bookingSettingsData?.artist_fields || []),
      ];
    },

    // eventFields: function () {
    //   return [
    //     ...(this.custom_fields.event_fields || []),
    //     ...(this.bookingSettingsData.event_fields || []),
    //   ];
    // },

    booking_localdetail_settingsCustomFieldLength() {
      return this.bookingSettingsData?.booking_localdetail_settings?.reduce(
        (accm, cur) => {
          const currentLocalDetailsFields = this.localDetailsFields(
            cur.local_details_type_id
          );
          const currentRowCount =
            currentLocalDetailsFields?.length < 1
              ? 1
              : currentLocalDetailsFields?.length;
          return accm + currentRowCount;
        },
        0
      );
    },
    lockJsonTypes(){
      const ljt =  [
        { key: "promoter", text: "Promoter"},
        { key: "contact", text: "Contact"}, 
        { key: "venue", text: "Venue"}
      ];

      const calendar_dates_lock_json_default = this.bookingSettingsData?.calendar_dates_lock_json_default ?? {};

      return ljt.map(r => {
        const value = calendar_dates_lock_json_default.hasOwnProperty(r.key) ? calendar_dates_lock_json_default[r.key] : 0;
        return {...r, value};
      });
    }
  },
  methods: {
    ...mapKeyToAction(storeNS, [
      ActionTypes.BookingSettingsData.FETCH.ALL,
      ActionTypes.UpdateBookingStatus,
      ActionTypes.SaveBookingStatus,
      ActionTypes.CreateBookingStatus,
      ActionTypes.RemoveBookingStatus,
      ActionTypes.TravelOption.INSERT.SINGLE,
      ActionTypes.TravelOption.UPDATE.SINGLE,
      ActionTypes.TravelOption.DELETE.SINGLE,
      ActionTypes.SaveConf,
      ActionTypes.UpdateConf,
      ActionTypes.UpdateCustomField,
      ActionTypes.AddCustomField,
      ActionTypes.DeleteCustomField,
      ActionTypes.LocalDetailsType.UPDATE.SINGLE,
      ActionTypes.LocalDetailsType.INSERT.SINGLE,
      ActionTypes.LocalDetailsType.DELETE.SINGLE,
      ActionTypes.LocalDetailsTypeField.INSERT.SINGLE,
      ActionTypes.LocalDetailsTypeField.UPDATE.SINGLE,
      ActionTypes.LocalDetailsTypeField.DELETE.SINGLE,
      ActionTypes.InvoiceItem.INSERT.SINGLE,
      ActionTypes.InvoiceItem.UPDATE.SINGLE,
      ActionTypes.InvoiceItem.DELETE.SINGLE,
      ActionTypes.InvoiceGroups.INSERT.SINGLE,
      ActionTypes.InvoiceGroupItems.FETCH.ALL,
      ActionTypes.InvoiceGroupItems.INSERT.SINGLE,
      ActionTypes.InvoiceGroups.DELETE.SINGLE,
      ActionTypes.InvoiceGroupItems.DELETE.SINGLE,
      ActionTypes.RssList.FETCH.SINGLE,
      ActionTypes.DEFAULT_LOCK_JSON.UPDATE.SINGLE,
      ActionTypes.TaskTemplate.INSERT.SINGLE,
      ActionTypes.TaskTemplate.DELETE.SINGLE,
      ActionTypes.TaskTemplateGroup.FETCH.ALL,
      ActionTypes.TaskTemplateGroup.INSERT.SINGLE,
      ActionTypes.TaskTemplateGroup.DELETE.SINGLE,
      ActionTypes.TaskTemplateGroup.UPDATE.SINGLE,
      ActionTypes.TaskTemplateGroupItems.INSERT.SINGLE,
      ActionTypes.TaskTemplateGroupItems.DELETE.SINGLE,
    ]),
    fetchData: function () {
      this[ActionTypes.BookingSettingsData.FETCH.ALL]();
    },
    tabSelectedRouting: function (tabId) {
      this.$router.push({
        name: "settings_booking_tab",
        params: {
          tab: tabId,
        },
      });
    },
    onSaveClick: async function () {
      await this[ActionTypes.SaveConf]();
      NotificationService.showNotification({
        text: "Request Settings Saved",
        timeout: 3000,
      });
    },
    onColorChange: function (payload) {
      const { booking_status_id, booking_status_colour } = payload;
      this[ActionTypes.UpdateBookingStatus]({
        booking_status_id,
        name: "booking_status_colour",
        value: booking_status_colour,
      });
    },
    onModalCancelled: function () {
      closeModalRoute(this, {
        booking_status_id: undefined,
        travel_option: undefined,
        travel_option_id: undefined,
        external_table: undefined,
        local_details_type_id: undefined,
        invoice_item_id: undefined,
        mode: undefined,
        task_template_id: undefined,
        add_task_template_group: undefined,
      });
    },
    onBookingStatusAdded: async function (bookingStatus) {
      await this[ActionTypes.CreateBookingStatus](bookingStatus);
      this.onModalCancelled();
    },
    onBookingStatusEdited: function (bookingStatus) {
      this[ActionTypes.SaveBookingStatus](bookingStatus);
      this.onModalCancelled();
    },
    onBookingStatusAddClick: function () {
      openModalRoute(this, "add_status");
    },
    onBookingStatusDeleteClick: function (booking_status_id) {
      this[ActionTypes.RemoveBookingStatus](booking_status_id);
    },
    onAddNewTravelOption: function () {
      openModalRoute(this, "add_travel_option");
    },
    onTravelOptionDelete: function ({ travel_option_id }) {
      this[ActionTypes.TravelOption.DELETE.SINGLE]({
        travel_option_id,
      });
    },
    onTravelOptionClick: function (travelOption) {
      console.log(travelOption);
      openModalRoute(this, "edit_travel_option", {
        travel_option: travelOption.travel_option_text,
        travel_option_id: travelOption.travel_option_id,
      });
    },
    onTravelOptionEdited: async function (value) {
      await this[ActionTypes.TravelOption.UPDATE.SINGLE]({
        travel_option_text: value,
        travel_option_id: this.$route.query.travel_option_id,
      });
      this.onModalCancelled();
    },
    onNewTravelOptionAdded: async function (value) {
      await this[ActionTypes.TravelOption.INSERT.SINGLE]({
        travel_option_text: value,
      });
      this.onModalCancelled();
    },
    onConfChanged: function (conf, { name, key, value }) {
      this[ActionTypes.UpdateConf]({ name, key, value, conf });
      if (!this.confChangeFlag) {
        this.confChangeFlag = true;
        NotificationService.showNotification({
          text: "Save Request settings by clicking the save Button",
          timeout: 3000,
          color: "info",
        });
      }
    },
    onFieldChanged: function (payload, field_data, conf_field) {
      console.log({ "payload, field_data": payload, field_data });
      if (!conf_field) {
        throw ConfigurationError("conf_field is required");
      }
      this[ActionTypes.UpdateCustomField]({
        ...payload,
        field_data,
        conf_field,
      });
    },
    onAddField: function (external_table) {
      openModalRoute(this, "add_custom_field", {
        external_table: external_table,
      });
    },
    getCustomFieldTitle: function (external_table) {
      return (
        {
          contacts: "contact",
          promoters: "promoter",
          calendar_dates: "event_l",
          booking_locations: "location",
          calendar_date_artists: "artist",
        }[external_table] || "..."
      );
    },
    onNewCustomFieldAdd: async function (value) {
      await this[ActionTypes.AddCustomField]({
        field_label: value,
        external_table: this.external_table,
      });
      this.onModalCancelled();
    },
    onCustomFieldDelete: function (
      conf_key,
      { custom_field_id, field_label },
      conf_field
    ) {
      if (!conf_field) {
        throw ConfigurationError("conf_field is required");
      }
      this[ActionTypes.DeleteCustomField]({
        conf_key,
        custom_field_id,
        field_label,
        conf_field,
      });
    },
    onLocalDetailsTypeChanged: function ({ item, name, value }) {
      this[ActionTypes.LocalDetailsType.UPDATE.SINGLE]({ item, name, value });
    },
    onNewLocalDetailsFieldAdded: async function (value) {
      console.log(value);
      if (!this.$route.query.local_details_type_id) {
        throw Error("Provide a valid Local Details Type Id in Route Query");
      }
      await this[ActionTypes.LocalDetailsTypeField.INSERT.SINGLE]({
        field_label: value,
        local_details_type_id: this.$route.query.local_details_type_id,
      });
      this.onModalCancelled();
    },
    onLocalDetailsFieldChanged: function ({ name, value, item }) {
      this[ActionTypes.LocalDetailsTypeField.UPDATE.SINGLE]({
        name,
        value,
        item,
      });
    },
    onLocalDetailsFieldDeleted: function ({ custom_field_id, external_table }) {
      this[ActionTypes.LocalDetailsTypeField.DELETE.SINGLE]({
        custom_field_id,
        external_table,
      });
    },
    onLocalDetailsAddClick: function () {
      openModalRoute(this, "add_local_details");
    },
    onAddLocalDetailsOk: async function (value) {
      await this[ActionTypes.LocalDetailsType.INSERT.SINGLE](value);
      this.onModalCancelled();
    },
    onLocalDetailsTypeDeleted: async function (item) {
      const confirmationResult = await confirmDelete(
        "Local Details",
        item.local_details_type_name
      );
      if (confirmationResult === "OK") {
        this[ActionTypes.LocalDetailsType.DELETE.SINGLE](item).then(
                (res) => {
                  this.onModalCancelled();
                }
              );
      }
      // ConfirmationService.create({
      //   subject: "Do you really want to delete this Local Details?",
      //   model: true,
      //   width: 500,
      //   completed: (res) => {
      //     switch (res) {
      //       case "OK": {
      //         this[ActionTypes.LocalDetailsType.DELETE.SINGLE](item).then(
      //           (res) => {
      //             this.onModalCancelled();
      //           }
      //         );
      //         break;
      //       }
      //     }
      //   },
      // });
    },
    onInvoiceItemFormDone: async function ({ mode, invoice_item }) {
      if (mode == "edit") {
        await this[ActionTypes.InvoiceItem.UPDATE.SINGLE](invoice_item);
      } else if (mode == "add") {
        await this[ActionTypes.InvoiceItem.INSERT.SINGLE](invoice_item);
      }
      this.onModalCancelled();
    },
    onInvoiceLineAddClick: function () {
      openModalRoute(this, "invoice_item_form", {
        mode: "add",
      });
    },
    onTaskTemplateAddClick: function () {
      openModalRoute(this, "task_template_form", {
        mode: "add",
      });
    },
    onTaskTemplateFormDone: async function ({ mode, task_template }) {
      // if (mode == "edit") {
      //   await this[ActionTypes.TaskTemplate.UPDATE.SINGLE](task_template);
      // } else if (mode == "add") {
      //   await this[ActionTypes.TaskTemplate.INSERT.SINGLE](task_template);
      // }
      await this[ActionTypes.TaskTemplate.INSERT.SINGLE](task_template);
      this.onModalCancelled();
    },
    onTaskTemplateDeleted: function (task_template_id) {
      this[ActionTypes.TaskTemplate.DELETE.SINGLE](task_template_id);
    },
    onTaskTemplateGroupSelected: function (task_group_id) {
      this.selectedTaskTemplateGroup = task_group_id;
      // this[ActionTypes.InvoiceGroupItems.FETCH.ALL](group_name);
      this[ActionTypes.TaskTemplateGroup.FETCH.ALL](task_group_id);
    },

    //delete later
    // onTemplateTaskGroupAddClick: function (payload) {
    //   openModalRoute(this, "add_task_template_group",{ external_table:payload });
    // },
    onNewTaskTemplateGroupCreated: async function (value) {
      await this[ActionTypes.TaskTemplateGroup.INSERT.SINGLE](value);
      this.onModalCancelled();
    },
    onTaskTemplateGroupUpdated: function (payload) {
      this[ActionTypes.TaskTemplateGroup.UPDATE.SINGLE](payload);
    },
    // onTaskTemplateGroupDeleted: function (payload) {
    //   this[ActionTypes.TaskTemplateGroup.DELETE.SINGLE](payload);
    // },
    onTaskTemplateGroupItemDelete: function (item) {
      // console.log('mdsir', item);
      this[ActionTypes.TaskTemplateGroupItems.DELETE.SINGLE]({
        task_group_id: this.selectedTaskTemplateGroup,
        task_template_id: item.task_template_id
      });
    },
    onInvoiceItemDeleted: function (invoice_item_id) {
      this[ActionTypes.InvoiceItem.DELETE.SINGLE](invoice_item_id);
    },
    fetchInvoiceGroupItems: function () {
      if (!this.selectedInvoiceGroup) {
        return;
      }
      this[ActionTypes.InvoiceGroupItems.FETCH.ALL](this.selectedInvoiceGroup);
    },
    onInvoiceGroupSelected: function (group_name) {
      this.selectedInvoiceGroup = group_name;
      this[ActionTypes.InvoiceGroupItems.FETCH.ALL](group_name);
    },
    onInvoiceGroupItemDelete: async function (item) {
      await this[ActionTypes.InvoiceGroupItems.DELETE.SINGLE](item);
      this.fetchInvoiceGroupItems();
    },
    onInvoiceGroupAddClick: function () {
      openModalRoute(this, "add_invoice_group");
    },
    onNewInvoiceGroupCreated: async function (value) {
      await this[ActionTypes.InvoiceGroups.INSERT.SINGLE](value);
      this.onModalCancelled();
    },
    onInvoiceGroupItemsDrop: function (event) {
      event.preventDefault();
      this.invoiceGroupItemsDragover = false;

      const parseResult = JSONX.tryParse(event.dataTransfer.getData("text"));
      if (!parseResult.success) {
        NotificationService.showNotification({
          text: "Please drop a valid Invoice Item",
          timeout: 5000,
          type: "error",
        });
        return;
      }

      if (!this.selectedInvoiceGroup) {
        NotificationService.showNotification({
          text: "Please Select a Valid Invoice Group before dropping an Invoice Item",
          timeout: 5000,
          type: "error",
        });
        return;
      }

      const invoice_item = parseResult.result;
      console.log(invoice_item, this.selectedInvoiceGroup);

      this[ActionTypes.InvoiceGroupItems.INSERT.SINGLE]({
        group_name: this.selectedInvoiceGroup,
        invoice_item,
      });
    },
    onInvoiceGroupItemsDragover: function (event) {
      event.preventDefault();
      console.log("dragover");
      this.invoiceGroupItemsDragover = true;
    },
    onInvoiceGroupItemsDragleave: function () {
      this.invoiceGroupItemsDragover = false;
    },
    onTaskTemplateGroupItemsDrop: function (event) {
      event.preventDefault();
      this.taskTemplateGroupItemsDragover = false;

      const parseResult = JSONX.tryParse(event.dataTransfer.getData("text"));
      if (!parseResult.success) {
        NotificationService.showNotification({
          text: "Please drop a valid Invoice Item",
          timeout: 5000,
          type: "error",
        });
        return;
      }

      if (!this.selectedTaskTemplateGroup) {
        NotificationService.showNotification({
          text: "Please Select a Valid Task Group before dropping an Task Template Item",
          timeout: 5000,
          type: "error",
        });
        return;
      }

      const task_template = parseResult.result;
      // console.log('mdsir: ', task_template, this.selectedTaskTemplateGroup);

      this[ActionTypes.TaskTemplateGroupItems.INSERT.SINGLE]({
        task_group_id: this.selectedTaskTemplateGroup,
        task_template_id: task_template.task_template_id
      });
    },
    onTaskTemplateGroupItemsDragover: function (event) {
      event.preventDefault();
      console.log("dragover");
      this.taskTemplateGroupItemsDragover = true;
    },
    onTaskTemplateGroupItemsDragleave: function () {
      this.taskTemplateGroupItemsDragover = false;
    },
    onInvoiceGroupDeleted: function (payload) {
      this[ActionTypes.InvoiceGroups.DELETE.SINGLE](payload);
    },
    onBookingDefaultValueChange: function ({name, value}) {
      console.log(name, value);
      this.$store.dispatch(UPDATE_CLIENT, { name, value });
    },
    getRssList: function (artist_id) {
      console.log("rss ", artist_id);
      this[ActionTypes.RssList.FETCH.SINGLE](artist_id);
    },

    // Local Details Methods
    getLocalDetailsHeight() {},
    localDetailsFields: function (local_details_type_id) {
      return (
        this.bookingSettingsData[`local_details_${local_details_type_id}`] || []
      );
    },
    onLockJsonCheckboxChange: function ({ name, value }) {
      // const checked = e.target.checked;
      // console.log(`mdsir: ${cl.key} -- ${checked}`);
      this[ActionTypes.DEFAULT_LOCK_JSON.UPDATE.SINGLE]({ key: name, value: value ? 1 : 0 });
    },

    //MARK: Methods
  },
};
</script>

<style lang="scss">
.cmp-settings-booking-settings {
  background: var(--bc-3, #f6f6f6);
  padding: 8px 32px;

  .dt-grid-layout {
    height: calc(100vh - 108px);
  }
  .booking-defaults-form {
    div:not(.fc2-auto-height) {
      .fc2 {
        --fc2-height: 30px;
      }
    } 
    .fc2-auto-height {
      .fc2 {
        label {
          &.fc2-label {
            white-space: pre-wrap !important;
          }
        }
      }
    }
  }
  .invoice-group-items-container {
    width: 100%;
    height: 100%;
    .select-text {
      display: none;
    }
    &.dragover {
      background: rgba(128, 128, 128, 0.192);
    }
    &.showselecttext {
      .select-text {
        display: flex;
        flex-direction: column;
        justify-content: center;
        height: 100%;

        color: var(--text-secondary);
        font-size: 22px;
        font-weight: 600;
        text-align: center;
      }
    }
  }
}
</style>
